import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { API_URL } from "../config";
import { useAuth } from "../providers";
import { useState } from "react";

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

function ImageUploaderAntd({ initialValue, onSaved, style }) {
    const { token } = useAuth();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState(
        initialValue
            ? [
                {
                    uid: "-1",
                    name: "image.png",
                    status: "done",
                    url: initialValue,
                },
            ]
            : []
    );

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChange = async ({ file, fileList: newFileList }) => {
        setFileList(newFileList);

        // Si se elimina la imagen, actualiza el campo y valida
        if (newFileList.length === 0) {
            onSaved("");
        }

        // Solo subir si es nuevo y no está en error
        if (file.status === "done" && file.response && file.response.url) {
            onSaved(file.response.url);
        }
    };

    // Custom request para subir a tu API
    const customRequest = async ({ file, onSuccess, onError }) => {
        const maxFileSize = 8 * 1024 * 1024;
        if (file.size > maxFileSize) {
            //message.error("El archivo es demasiado grande (máx. 8MB)");
            onError();
            return;
        }
        if (!token) {
            //message.error("No hay token de autenticación");
            onError();
            return;
        }
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(`${API_URL}/images/upload`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });
            if (response.ok) {
                const data = await response.json();
                onSuccess(data, file);
                //message.success("Imagen subida con éxito");
            } else {
                //message.error("Error al subir la imagen");
                onError();
            }
        } catch (error) {
            //message.error("Error en la conexión");
            onError();
        }
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Subir</div>
        </div>
    );

    return (
        <div style={style}>
            <Upload
                customRequest={customRequest}
                listType="picture-circle"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                maxCount={1}
                accept="image/*"
            >
                {fileList.length >= 1 ? null : uploadButton}
            </Upload>
            {previewImage && (
                <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                />
            )}
        </div>
    );
}

export default ImageUploaderAntd;